import $axios from "../../../core/rest/axios";
export default class CreateService {
    create(data) {
        return $axios.post("/servlet/proxy/enavrhy/navrhy", data);
    }
    createNewsletter(data) {
        return $axios.post("/servlet/proxy/enavrhy/newsletter", data);
    }
}
